import React from 'react';
import styled from 'styled-components';
import { SvgIcon } from '../../../../components/Icon';

const Container = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  column-gap: 4px;
  width: 153px;
  height: 32px;
  border: 1px solid currentColor;
  border-radius: 4px;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: #fff;
  &:hover {
    cursor: pointer;
    color: #fff;
  }
`;

const WatchOverviewAction = () => (
  <Container
    href="https://docs.kubit.ai/docs/introduction-to-kubit-video"
    target="_blank"
    rel="noopener noreferrer"
  >
    <SvgIcon name="play" width={24} height={24} customFill="currentColor" />
    Watch overview
  </Container>
);

export default WatchOverviewAction;
